import * as types from './types'
import storage from '@/plugins/storage'
import store from '@/store'

export default {
  [types.SET_DAYS](state, days) {
    state.retrospectiveDay = days
    storage.session.setItem(types.CONTACT_DAYS, days)
  },
  [types.SET_STATUS](state, status) {
    state.status = status
    storage.session.setItem(types.CONTACT_STATUS, status)
  },
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
    storage.session.setItem(types.CONTACT_SEARCH_TERM, text)
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
    storage.session.setItem(types.CONTACT_PAGE_SIZE, pageSize)
  },
  [types.SET_SORT_DIR](state, sortDir) {
    state.sortDir = sortDir
    storage.session.setItem(types.CONTACT_SORT_DIR, sortDir)
  },
  [types.SET_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy
    storage.session.setItem(types.CONTACT_ORDER_BY, orderBy)
  },
  [types.SET_FILTER_OPTIONS](state, data) {
    state.filterOptions = data
  },
  [types.SET_FILTER_BY](state, filterBy) {
    state.filterBy = filterBy
  },
  [types.ADD_CONTACT](state, contact) {
    state.contact = JSON.parse(JSON.stringify(contact))
  },
  [types.UPDATE_CONTACT](state, data) {
    if (state.visit !== null && data !== null) {
      switch (data.name) {
        case 'contact':
          state.contact.contact = parseInt(data.value)
          break
        case 'contactType':
          state.contact.contactType = parseInt(data.value)
          break
        case 'isCompany':
          state.contact.isCompany = data.value
          break
        case 'salutation':
          state.contact.salutation = data.value
          break
        case 'insuranceId':
          state.contact.insuranceId = data.value
          break
        case 'insuranceNumber':
          state.contact.insuranceNumber = data.value
          break
        case 'firstName':
          state.contact.firstName = data.value
          break
        case 'lastName':
          state.contact.lastName = data.value
          break
        case 'notes':
          state.contact.notes = data.value
          break
        case 'language':
          state.contact.language = parseInt(data.value)
          break
        case 'timezone':
          state.contact.timezone = parseInt(data.value)
          break
        case 'servicetype':
          state.contact.servicetype = parseInt(data.value)
          break
        case 'isFirm':
          state.contact.isFirm = data.value
          break
        case 'isInactive':
          state.contact.isInactive = data.value
          break
        case 'firmClass':
          state.contact.firmClass = parseInt(data.value)
          break
      }
      console.log('Updated contact:', state.contact)
    }
  },
  [types.SET_CONTACT_CHECKED](state, data) {
    for (let contact of state.contacts.items) {
      if (contact.contact === data.contact) {
        contact.isChecked = data.isChecked
        break
      }
    }
    state.isContactChecked = false
    state.isVendorChecked = false
    let numChecked = 0
    for (let contact of state.contacts.items) {
      if (contact.isChecked) {
        numChecked++
      }
      if (numChecked >= 2) {
        state.isContactChecked = true
        break
      }
      if (numChecked >= 1 && state.isVendors) {
        state.isVendorChecked = true
      }
    }
  },
  [types.SET_CONTACT](state, data) {
    state.contact = data
  },
  [types.SET_CONTACTS](state, data) {
    state.contacts = []
    state.isContactChecked = false
    state.isVendorChecked = false
    state.isVendors = data.isVendors
    if (data.data !== undefined && data.data !== null) {
      if (data.data.items !== undefined && data.data.items !== null) {
        for (let item of data.data.items) {
          item.isChecked = false
        }
        state.contacts = data.data
        store.dispatch('lookups/setInsurance', {
          name: 'data',
          value: state.contacts.items
        })
      }
    }
  },
  [types.SET_CONTACTS_FOUND](state, data) {
    state.contactsFound = []
    if (data !== undefined && data !== null) {
      state.contactsFound = data
    }
  },
  [types.SET_ADDRESSES_FOUND](state, data) {
    state.addressesFound = []
    if (data !== undefined && data !== null) {
      state.addressesFound = data
    }
  },
  [types.SET_PHONES_FOUND](state, data) {
    state.phonesFound = []
    if (data !== undefined && data !== null) {
      state.phonesFound = data
    }
  },
  [types.SET_BIRTHDAYS_FOUND](state, data) {
    state.birthdaysFound = []
    if (data !== undefined && data !== null) {
      state.birthdaysFound = data
    }
  },
  [types.SET_CONTACT_ADDRESS](state, data) {
    state.address = null
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.address = data
      }
    }
  },
  [types.SET_CONTACT_ADDRESSES](state, data) {
    state.contactAddresses = []
    if (data !== undefined && data !== null) {
      if (data.items !== null) {
        for (let item of data.items) {
          item.isChecked = false
          item.isPrimary = false
          if (item.primary === 'P') {
            item.isPrimary = true
          }
          item.isShared = false
          if (item.isShared === 'Y') {
            item.isShared = true
          }
        }
        state.contactAddresses = data.items
      }
    }
  },
  [types.SET_CONTACT_PHONES](state, data) {
    state.contactPhones = []
    if (data !== undefined && data !== null) {
      if (data.items !== null) {
        for (let item of data.items) {
          item.isChecked = false
          item.isPrimary = false
          if (item.primary === 'P') {
            item.isPrimary = true
          }
          item.isShared = false
          if (item.isShared === 'Y') {
            item.isShared = true
          }
        }
        state.contactPhones = data.items
      }
    }
  },
  [types.SET_CONTACT_EMAILS](state, data) {
    state.contactEmails = []
    if (data !== undefined && data !== null) {
      if (data.items !== null) {
        for (let item of data.items) {
          item.isChecked = false
          item.isPrimary = false
          if (item.primary === 'P') {
            item.isPrimary = true
          }
        }
        state.contactEmails = data.items
      }
    }
  },
  [types.SAVE_ADDRESS](state, data) {
    let found = false
    let lookups = store.getters['lookups/lookups']
    let addressTypeName = ''
    for (let lookup of lookups['AddressType']) {
      if (lookup.id === parseInt(data.address.addressType)) {
        addressTypeName = lookup.name
        break
      }
    }
    let stateProvinceName = ''
    for (let lookup of lookups['StateProvince']) {
      if (lookup.id === parseInt(data.address.stateProvince)) {
        stateProvinceName = lookup.name
        break
      }
    }
    if (data.address.contactAddress !== 0) {
      for (let address of state.contactAddresses) {
        if (address.contactAddress === data.address.contactAddress) {
          found = true
          address.addressType = data.address.addressType
          address.addressTypeName = addressTypeName
          address.addressLines = data.address.addressLines
          address.city = data.address.city
          address.stateProvince = data.address.stateProvince
          address.stateProvinceName = stateProvinceName
          address.postalCode = data.address.postalCode
          address.country = data.address.country
          address.addressNote = data.address.addressNote
          address.isChecked = false
          break
        }
      }
    }
    if (found === false) {
      let newAddress = {
        address: data.result.address,
        addressFull: data.address.addressLines,
        addressType: data.address.addressType,
        addressTypeName: addressTypeName,
        city: data.address.city,
        contact: data.result.contact,
        contactAddress: data.result.contactAddress,
        isShared: false,
        mainAddress: null,
        postalCode: data.address.postalCode,
        primary: '',
        stateProvince: data.address.stateProvince,
        stateProvinceName: stateProvinceName,
        isChecked: false
      }
      state.contactAddresses.push(newAddress)
    }
  },
  [types.DELETE_ADDRESS](state, data) {
    let addresses = []
    if (data.result.contact !== -1 && data.data.contactAddress !== 0) {
      for (let address of state.contactAddresses) {
        address.isChecked = false
        if (address.contactAddress !== data.data.contactAddress) {
          addresses.push(address)
        }
      }
    }
    state.contactAddresses = addresses
  },
  [types.SET_PRIMARY_ADDRESS](state, id) {
    for (let address of state.contactAddresses) {
      address.isChecked = false
      address.primary = ''
      address.isPrimary = false
      if (address.contactAddress === id) {
        address.primary = 'P'
        address.isPrimary = true
      }
    }
  },
  [types.SET_CHECKED_ADDRESS](state, data) {
    for (let address of state.contactAddresses) {
      if (address.contactAddress === data.contactAddress) {
        address.isChecked = data.isChecked
        break
      }
    }
  },
  [types.SAVE_PHONE](state, data) {
    let found = false
    let lookups = store.getters['lookups/lookups']
    let phoneTypeName = ''
    for (let lookup of lookups['PhoneType']) {
      if (lookup.id === parseInt(data.phone.phoneType)) {
        phoneTypeName = lookup.name
        break
      }
    }
    let isPrimary = false
    if (data.phone.contactPhone !== 0) {
      for (let phone of state.contactPhones) {
        if (phone.contactPhone === data.phone.contactPhone) {
          found = true
          phone.phoneType = data.phone.phoneType
          phone.phoneNo = data.phone.phoneNo
          phone.extension = data.phone.extension
          phone.phoneNote = data.phone.phoneNote
          phone.phoneTypeName = phoneTypeName
          phone.isChecked = false
          isPrimary = phone.isPrimary
          break
        }
      }
    }
    if (found === false) {
      isPrimary = data.result.isPrimary
      let newPhone = {
        contactPhone: data.result.contactPhone,
        contact: data.result.contact,
        phone: data.result.phone,
        phoneNo: data.phone.phoneNo,
        extension: data.phone.extension,
        phoneType: data.phone.phoneType,
        phoneTypeName: phoneTypeName,
        phoneNote: data.phone.phoneNote,
        isShared: false,
        primary: '',
        isPrimary: false,
        isChecked: false
      }
      state.contactPhones.push(newPhone)
    }
    if (isPrimary) {
      if (state.contacts !== undefined && state.contacts !== null) {
        if (state.contacts.items !== undefined && state.contacts.items !== null) {
          for (let contact of state.contacts.items) {
            if (contact.contact === data.result.contact) {
              contact.phoneNo = data.phone.phoneNo
              break
            }
          }
        }
      }
    }
  },
  [types.DELETE_PHONE](state, data) {
    let phones = []
    if (data.result.contact !== -1 && data.data.contactPhone !== 0) {
      for (let phone of state.contactPhones) {
        if (phone.contactPhone !== data.data.contactPhone) {
          phones.push(phone)
        }
      }
    }
    state.contactPhones = phones
  },
  [types.SET_PRIMARY_PHONE](state, data) {
    let phoneNo = ''
    for (let phone of state.contactPhones) {
      phone.isChecked = false
      phone.primary = ''
      phone.isPrimary = false
      if (phone.contactPhone === data.id) {
        phone.primary = 'P'
        phone.isPrimary = true
        phoneNo = phone.phoneNo
      }
    }
    if (state.contacts !== undefined && state.contacts !== null) {
      if (state.contacts.items !== undefined && state.contacts.items !== null) {
        for (let contact of state.contacts.items) {
          if (contact.contact === data.contact) {
            contact.phoneNo = phoneNo
            break
          }
        }
      }
    }
  },
  [types.SET_CHECKED_PHONE](state, data) {
    for (let phone of state.contactPhones) {
      if (phone.contactPhone === data.contactPhone) {
        phone.isChecked = data.isChecked
        break
      }
    }
  },
  [types.SAVE_EMAIL](state, data) {
    let found = false
    let lookups = store.getters['lookups/lookups']
    let emailTypeName = ''
    for (let lookup of lookups['EmailType']) {
      if (lookup.id === parseInt(data.email.emailType)) {
        emailTypeName = lookup.name
        break
      }
    }
    let isPrimary = false
    if (data.email.contactEmail !== 0) {
      for (let email of state.contactEmails) {
        if (email.contactEmail === data.email.contactEmail) {
          found = true
          email.emailType = data.email.emailType
          email.emailAddress = data.email.emailAddress
          email.emailTypeName = emailTypeName
          email.isChecked = false
          isPrimary = email.isPrimary
          break
        }
      }
    }
    if (found === false) {
      isPrimary = data.result.isPrimary
      let newEmail = {
        contactEmail: data.result.contactEmail,
        contact: data.result.contact,
        emailAddress: data.email.emailAddress,
        emailType: data.email.emailType,
        emailTypeName: emailTypeName,
        primary: '',
        isPrimary: false,
        isChecked: false
      }
      state.contactEmails.push(newEmail)
    }
    if (isPrimary) {
      if (state.contacts !== undefined && state.contacts !== null) {
        if (state.contacts.items !== undefined && state.contacts.items !== null) {
          for (let contact of state.contacts.items) {
            if (contact.contact === data.result.contact) {
              contact.emailAddress = data.email.emailAddress
              break
            }
          }
        }
      }
    }
  },
  [types.DELETE_EMAIL](state, data) {
    let emails = []
    if (data.result.contact !== -1 && data.data.contactEmail !== 0) {
      for (let email of state.contactEmails) {
        if (email.contactEmail !== data.data.contactEmail) {
          emails.push(email)
        }
      }
    }
    state.contactEmails = emails
  },
  [types.SET_PRIMARY_EMAIL](state, data) {
    let emailAddress = ''
    for (let email of state.contactEmails) {
      email.isChecked = false
      email.primary = ''
      email.isPrimary = false
      if (email.contactEmail === data.id) {
        email.primary = 'P'
        email.isPrimary = true
        emailAddress = email.emailAddress
      }
    }
    if (state.contacts !== undefined && state.contacts !== null) {
      if (state.contacts.items !== undefined && state.contacts.items !== null) {
        for (let contact of state.contacts.items) {
          if (contact.contact === data.contact) {
            contact.emailAddress = emailAddress
            break
          }
        }
      } else {
        store.dispatch('users/setUserEmail', { Contact: data.contact, EmailAddress: emailAddress })
      }
    } else {
      store.dispatch('users/setUserEmail', { Contact: data.contact, EmailAddress: emailAddress })
    }
  },
  [types.SET_CHECKED_EMAIL](state, data) {
    for (let email of state.contactEmails) {
      if (email.contactEmail === data.contactEmail) {
        email.isChecked = data.isChecked
        break
      }
    }
  },
  [types.SET_RELATED](state, data) {
    state.related = null
    if (data !== undefined && data !== null) {
      if (data !== '') {
        for (let item of data) {
          item.isChecked = false
        }
        state.related = data
      }
    }
  },
  [types.ADD_ADDRESS](state, address) {
    state.contactAddresses.push(address)
  },
  [types.REMOVE_ADDRESS](state, id) {
    state.contactAddresses = state.contactAddresses.filter((x) => parseInt(x.contactAddress) !== parseInt(id))
  },
  [types.ADD_PHONE](state, phone) {
    state.contactPhones.push(phone)
  },
  [types.REMOVE_PHONE](state, id) {
    state.contactPhones = state.contactPhones.filter((x) => parseInt(x.contactPhone) !== parseInt(id))
  },
  [types.ADD_EMAIL](state, email) {
    state.contactEmails.push(email)
  },
  [types.REMOVE_EMAIL](state, id) {
    state.contactEmails = state.contactEmails.filter((x) => parseInt(x.contactEmail) !== parseInt(id))
  },
  [types.SET_ITEM](state, item) {
    switch (item.type) {
      case 'Address':
        var address = state.contactAddresses.find((x) => parseInt(x.contactAddress) === parseInt(item.id))
        address[item.property] = item.value
        break
      case 'Phone':
        var phone = state.contactPhones.find((x) => parseInt(x.contactPhone) === parseInt(item.id))
        phone[item.property] = item.value
        break
      case 'Email':
        var email = state.contactEmails.find((x) => parseInt(x.contactEmail) === parseInt(item.id))
        email[item.property] = item.value
        break
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/contacts/mutations.js